// Party Scroll v6 — poster placeholder colors.
//
// In the v6 design, the solid color block on an event/party card is a
// *placeholder* for the poster image. When an event has no posterUrl we fill
// that block with a deterministic color drawn from the disco palette so the
// same event always gets the same color (stable across renders and sessions).

// Curated subset of the disco palette that reads well as a full-bleed fill
// behind white/black text. Ordered for visual variety between adjacent cards.
const PLACEHOLDER_COLORS = [
  '#8c8e90', // slate
  '#ee5e8a', // coral
  '#f9b82c', // orange
  '#37a6b5', // teal
  '#e462a5', // pink
  '#28405a', // navy
  '#d375bd', // orchid
  '#495962', // slateDeep
  '#25b6e2', // azure
  '#dd5f54', // rust
  '#1a82e4', // cobalt
  '#40cac9', // teal-bright
];

// Cheap, stable string hash (djb2). Any stable key works: event id, invite
// code, or title as a last resort.
function hashKey(key) {
  const str = String(key ?? '');
  let hash = 5381;
  for (let i = 0; i < str.length; i += 1) {
    hash = ((hash << 5) + hash + str.charCodeAt(i)) & 0xffffffff;
  }
  return Math.abs(hash);
}

/**
 * Deterministic placeholder fill color for an event with no poster.
 * @param {string|number} key - stable id (event id / invite code / title)
 * @returns {string} hex color
 */
export function posterPlaceholder(key) {
  return PLACEHOLDER_COLORS[hashKey(key) % PLACEHOLDER_COLORS.length];
}

export default posterPlaceholder;
